import React from 'react';
import PropTypes from 'prop-types';

import BaseComponent from 'components/BaseComponent';

class Section extends BaseComponent {
  className = 'ts-Section';

  static propTypes = {
    children: PropTypes.any,
  };

  render() {
    return (
      <div className={ this.rootcn() }>
        { this.props.children }
      </div>
    );
  }
}

export default Section;
